import { css } from '@emotion/core';
import { Theme } from 'features/Theme';

const styles = {
  button: (theme: Theme) => css`
    font-size: inherit;
    color: ${theme.mui.palette.primary.main};
    background: none;
    border: none;
    cursor: pointer;
  `,
  collapsibleContainer: (theme: Theme) => css`
    padding: ${theme.mui.spacing(1)}px 0;
  `,
  row: css`
    display: flex;
    align-items: center;
  `,
};

export default styles;
